module.exports = __webpack_public_path__ + "img/banner-tc1-m.04ad0e9b.jpg";